import Roles from "@/shared/Roles";

// Roles allowed into the evaluation (APER) screens — mirrors the officer
// "Evaluations" nav item. Enforced by the officer router's role guard.
const evaluationRoles = [
  Roles.Supervisor,
  Roles.ExternalExaminer,
  Roles.Hod,
  Roles.Dean,
  Roles.DeanSpgs,
  Roles.SecretarySpgs,
  Roles.InternalExaminer,
  Roles.Reviewer
];

// Result Uploads / Audit page. Backend also allows LECTURER for read endpoints,
// but per product decision the UI is gated to result/system admins only.
const resultAuditRoles = [Roles.Admin, Roles.SuperAdmin, Roles.ResultAdmin];

export const sharedRoutes = [
  {
    path: '/evaluation/templates',
    component: () => import('@/pages/aper/TemplatesView.vue'),
    meta: { roles: evaluationRoles }
  },

  {
    path: '/evaluation/templates/:id',
    component: () => import('@/pages/aper/TemplateView.vue'),
    meta: { roles: evaluationRoles }
  },

  {
    path: '/evaluation/evaluations',
    component: () => import('@/pages/aper/EvaluationsListView.vue')
  },

  {
    path: '/evaluation/evaluations/:id',
    component: () => import('@/pages/aper/EvaluationView.vue'),
    props: true,
    meta: { roles: evaluationRoles }
  },

  {
    path: '/evaluation/evaluations/:id/summary',
    component: () => import('@/pages/aper/EvaluationSummaryView.vue'),
    props: true,
    meta: { roles: evaluationRoles }
  },

  {
    path: '/result_audit',
    component: () => import('@ui/pages/shared/ResultAuditPage.vue'),
    meta: { roles: resultAuditRoles }
  },
]
